"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendar_en_us = void 0;
function calendar_en_us() {
    return {
        "calendars.navigation.title": "Calendars",
        "calendars.navigation.subtitle": "Create custom calendars and calendar entries.",
        "calendars.overview.title": "All Calendars",
        "calendars.creation.title": "Create new calendar",
        "calendars.editor.title": "Edit calendar",
        "calendars.entries.create": "Create Event",
        "calendars.entries.edit": "Edit Event",
        "calendars.entries.creation.errors.calendarnotfound": "Calendar not found",
        "calendars.entries.creation.errors.nocalendargiven": "No calendar given",
        "calendars.actions.createcalendar": "create calendar",
        "calendars.config.labels.headline": "Config calendar times",
        "calendars.config.labels.description": "Specify the start and end time of your calendar here.",
        "calendars.config.labels.starttime.title": "Start time",
        "calendars.config.labels.starttime.description": "Enter the time you want the calendar to start. Format: hh:mm:ss, e.g.: '08:00:00'",
        "calendars.config.labels.endtime.title": "End time",
        "calendars.config.labels.endtime.description": "Enter the time you want the calendar to end. Format: hh:mm:ss, e.g.: '22:00:00'",
        "calendars.config.errors.timeformat.title": "Wrong time format",
        "calendars.config.errors.timeformat.message": "In the configuration, please enter the start and end time of your calendar in the format 'hh:mm:ss'."
    };
}
exports.calendar_en_us = calendar_en_us;
